import { ROUTE_INVESTING_IDEA_DISCOVERY_PAGE } from '@/constants/routes';
import { GridViewOptions } from '../constants/constants';

export default function useDividendInvestingIdea(market: string) {
  if (market === '') return undefined;

  return {
    results: 0,
    linkToInvestingIdea: {
      type: ROUTE_INVESTING_IDEA_DISCOVERY_PAGE,
      payload: {
        id: GridViewOptions.GRID_VIEW_DIVIDEND_NEW,
        name: 'top-dividend-stocks',
        market: market.toLowerCase(),
      },
    },
  };
}
